import { ref, uploadBytes, getStorage } from 'firebase/storage';
import { getSessionUserAdminStatus } from '@client/selectors/helpers/login';
import type { ListenerEffectAPI } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from '@client/store';

/**
 * Upload a file and return the snapshot upon completion.
 * Image url can be retrieved with `snapshot.downloadURL`
 * @param path
 * @param filename
 * @param fileObject
 */
export const uploadFile = async (listenerApi: ListenerEffectAPI<RootState, AppDispatch>, path: string, filename: string, fileObject: File | Blob) => {
  try {
    const state = listenerApi.getState();

    const firebase = window.Firebase;
    const storage = getStorage(firebase.app);

    const isAdmin = getSessionUserAdminStatus(state);

    const metadata = {
      customMetadata: {
        requiresOptimization: 'Yes',
        visionChecked: isAdmin ? 'Yes' : 'No',
      },
    };

    const storageRef = ref(storage, `${path}/${filename}`);
    const data = await uploadBytes(storageRef, fileObject, metadata);

    return {
      downloadUrl: data.ref.fullPath,
      status: true,
    };
  } catch (e) {
    console.log(e);

    return {
      status: false,
      message: e.message,
    };
  }
};
